/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  DataGridPro,
  GridValidRowModel,
  type GridRenderCellParams,
  GridRowParams,
  GridSortModel,
} from '@mui/x-data-grid-pro';
import React, {
  ReactNode,
  useState,
  type FC,
  useMemo,
  useCallback,
  useEffect,
  useRef
} from 'react';
import {
  AlarmCards,
  SelectDropDown,
  SortedAscendingIcon,
  SortedDescendingIcon,
  alarmCardMapper,
  useAppDispatch,
  useAppSelector,
  NoDataComponentAlarms,
  LoginLoader,
  CustomTooltipWithLabel,
} from '../../../globalUtils/globalExports';

import { useNavigate } from 'react-router-dom';
import { formatRelativeTimeForTable ,formatRelativeTimeForTableIST} from '../../../globalUtils/globalHooks';
import {
  AlarmCardSkeleton,
  AlarmTableSkeleton,
} from '../../../globalUtils/SkeletonDesign/SkeletonDesign';
import {HorizontalNavbar} from '../../../globalUtils/globalExports' 
import { CardPropTypes } from '../../../globalUtils/AlarmCards/AlarmCards';
import { Arrow, Icon, IconWithTooltip } from '../../../globalUtils/globalIcons';
import { LicenseInfo } from '@mui/x-license-pro';
import './Nocsidebar.css'
import { getAcDashboardReducer, getAcReferenceDataReducer } from '../../rmsReduxStore/acReduxExports';
import { getCurrentAcFiltersValues } from '../../rmsReduxStore/acFiltersRedux/acFiltersCreators';
import { fetchAcLatestChargerDetails } from '../../rmsReduxStore/acNocDashboardRedux/acNocDashboardCreator';
import { fetchNewAcDashboardAlarmSummaryList } from '../../rmsReduxStore/acDashboardRedux/acDashboardCreator';
import { fetchAcAlarmListData } from '../../rmsReduxStore/acAlarmsRedux/acAlarmCreators';
export interface AlarmItem {
  id: string;
  name: string;
  severity: 'Major' | 'Critical' | 'Minor' | string; // allow custom values
  setTime: string; // ISO date string
}
export interface AlarmSeverityCount {
  severity: 'Major' | 'Critical' | 'Minor' | string;
  count: number;
}


interface AlarmDetails {
  severityWiseCount: AlarmSeverityCount[];
  alarmsList: AlarmItem[];
}

interface AlarmSummaryPropTypes {
  loader?: boolean;
  isNewDashBoard?: boolean;
  getFilterValue?: Function;

  // ➕ add this
  alarmDetails?: ILatestChargerAlarmDetails;  
  alarmDurationRef: React.MutableRefObject<string | null>; 
  selectedChargerRef:React.MutableRefObject<string | null>;
  searchTermRef:React.MutableRefObject<string | null>;
}

const AcNocAlarmSummary: FC<AlarmSummaryPropTypes> = (props) => {
const headerdata =   [{
    id: 'allActiveAlarms',
    text: 'All Active Alarms',
    isAccessible: true,
  },
  {
    id: 'alarmsInLastHour',
    text: 'Alarms in last 1 hour',
    isAccessible: true,
  },
]
  const { loader, isNewDashBoard, getFilterValue, alarmDetails ,alarmDurationRef,selectedChargerRef,searchTermRef} = props;
  const newlist = alarmDetails?.alarmsList;
  const alaramcount = alarmDetails?.severityWiseCount;
  const alarmCountData = React.useMemo(() => {
  const list = alarmDetails?.severityWiseCount ?? [];

  // extract counts (default 0 when missing)
  const critical = list.find(i => i.severity.toUpperCase() === 'CRITICAL')?.count ?? 0;
  const major = list.find(i => i.severity.toUpperCase() === 'MAJOR')?.count ?? 0;
  const minor = list.find(i => i.severity.toUpperCase() === 'MINOR')?.count ?? 0;

  const total = critical + major + minor;

  return [
    { severity: 'TOTAL', alarmCount: total },
    { severity: 'CRITICAL', alarmCount: critical },
    { severity: 'MAJOR', alarmCount: major },
    { severity: 'MINOR', alarmCount: minor },
  ];
}, [alarmDetails]);

  LicenseInfo.setLicenseKey('592863905b14abe78770cb5851e88222Tz04Nzg4MixFPTE3NDM5MjM4MzUwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  
  const { alarmSeverityReferenceData } = useAppSelector(getAcReferenceDataReducer);
  const { newDashboardAlarmSummaryInfo, newDashboardAlarmSummaryTableLoader } = useAppSelector(getAcDashboardReducer);
  const [value, setValue] = useState<IGeneralReferenceData>();
  const [selectedNav, setSelectedNav] = useState<'allActiveAlarms' | 'alarmsInLastHour'>('allActiveAlarms');
  const [selectedAlarmCard, setSelectedAlarmCard] = useState<string>('')
  const subHeaderRef = useRef<HTMLDivElement>(null)

const handleNavBtnClick = useCallback(async (val) => {
  setSelectedNav(val);
  const filters = getCurrentAcFiltersValues('nocDashboard', false);
  if(val === 'alarmsInLastHour'){
    alarmDurationRef.current = 'last1Hr';
    await dispatch(fetchAcLatestChargerDetails({ filters:filters, charger:selectedChargerRef?.current, searchTerm:searchTermRef?.current,alarmDuration: 'last1Hr'}));
  } else {
    alarmDurationRef.current = '';
    await dispatch(fetchAcLatestChargerDetails({ filters:filters, charger:selectedChargerRef?.current, searchTerm:searchTermRef?.current,alarmDuration:''}));
  }

}, []);


    const navBarconfigurations = useMemo(() => {
    return {
      selectedNav: selectedNav,
      navList: headerdata?.filter((nav) => nav?.isAccessible),
      onNavClick: handleNavBtnClick
    }
  }, [selectedNav])
  const handleCardClick = useCallback((props: CardPropTypes): void => {
    // eslint-disable-next-line react/prop-types
    const { headerText } = props;
    // eslint-disable-next-line react/prop-types
    const value = headerText === 'TOTAL' ? 'all' : headerText[0] + headerText.slice(1).toLowerCase();
    // setAcRedirectedStateForAlarmFilters(true, value)(dispatch)
    //   .then((res) => {
    //     if (res === 'Action dispatched successfully') {
    //       navigate('/ac/alarms', {
    //         state: { severityId: value }
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     console.error('Error dispatching action:', error); // Handle error
    //   });

  }, [alarmSeverityReferenceData])

  const handleSortModelChange = useCallback(
    (model: GridSortModel) => {
      if (model?.length > 0) {
        const sortOrder =
          model?.[0]?.sort === 'asc'
            ? 'ascending'
            : model?.[0]?.sort === 'desc'
              ? 'descending'
              : ''
        const dashboardCurrentFilters = getCurrentAcFiltersValues('acdashboard');
        const sortField = (model?.[0]?.field?.length ?? 0) > 0 ? model?.[0]?.field : null;
        if(isNewDashBoard){
          dispatch(fetchNewAcDashboardAlarmSummaryList({ sortBy: sortField, order: sortOrder, pageSize: 8, pageNumber: 1, filters: dashboardCurrentFilters }))
        }
        else{
          dispatch(fetchAcAlarmListData({ sortBy: sortField, order: sortOrder, pageSize: 5, pageNumber: 1, filters: dashboardCurrentFilters }))
        }

      }
    }, [])

  const handleSelectedAlarm = useCallback((event, data) => {
    navigate('/ac/alarm?alarmId=' + data?.id, {
      state: {
        row: data,
        calledFrom: isNewDashBoard ? 'newDashboard' : 'dashboard'
      },
    });
  }, []);

  const columns = useMemo(() => {
    return [
      {
        field: 'severity',
        headerName: 'Alarm',
        minWidth: 50,
        maxWidth: 52,
        headerClassName: 'dashboard__alarm__header-severity',
        renderHeader: (): JSX.Element => {
          return (
            <div className='dashboard__alarm__header__alarm-icon'>
              <Icon iconClassName={'total__alarm__icon' + (isNewDashBoard ? ' iconScaleDown09' : '')} />
            </div>
          )
        },
        renderCell: (
          params: GridRenderCellParams<GridValidRowModel>
        ): ReactNode => {
          const rowData = params?.row;


          return (
            <div className="alarm__summary__name icon__severity">

              <Icon
                iconClassName={
                  alarmCardMapper[rowData?.severity]?.alarmSummaryIcon + (isNewDashBoard ? ' iconScaleDown09' : '')
                }
              />

            </div>
          );
        },
      },
      {
        field: 'alarmVisibleName',
        flex: 1.25,
        headerName: 'Alarm',
        minWidth: 100,
        renderCell: (
          params: GridRenderCellParams<GridValidRowModel>
        ): ReactNode => {
          const rowData = params?.row;
          return (
            <div className="alarm__summary__name">
              <div className="alarm__summary__name">
                { isNewDashBoard ? <CustomTooltipWithLabel label={rowData?.alarmVisibleName} labelId={rowData?.alarmVisibleName} /> : rowData?.alarmVisibleName }
              </div>
            </div>
          );
        },
      },
      {
        field: 'alarmSetTime',
        flex: 1,
        headerName: 'Time',
        minWidth: 90,
        renderCell: (
          params: GridRenderCellParams<GridValidRowModel>
        ): ReactNode => {
          const rowData = params?.row;
          const date =rowData?.alarmSetTime;
          if(isNewDashBoard) return <CustomTooltipWithLabel label={formatRelativeTimeForTable(date)} labelId={formatRelativeTimeForTable(date)} />
          return formatRelativeTimeForTableIST(date);
        },
      }
    ];
  }, [alarmCardMapper]);




    const getRows = useCallback(() => {
    const updatedAlarmsData =
      newlist !== null 
        ? newlist?.map((alarm) => {
          const { id, name, setTime ,severity } = alarm;
          return { id: id , alarmVisibleName:name , alarmSetTime:setTime,severity:severity?.toUpperCase()};
        })
        : [];
    return updatedAlarmsData ?? [];
  }, [newlist]);


  return (

    <div className='noc__dashboard__alarm__summary__container'  >
      <div className="noc__dashboard__alarm__summary-header-wrap">
                  <div ref={subHeaderRef} className="configure__notification__container__sub__header">
            <div >
              <HorizontalNavbar
                selectedNav={navBarconfigurations?.selectedNav}
                navList={navBarconfigurations?.navList}
                onNavClick={(event, val) => { event?.stopPropagation(); navBarconfigurations?.onNavClick?.(val) }}
              />
            </div>
          </div>
      </div>

      {!alaramcount ? (
        <AlarmCardSkeleton />
      ) : (
        <div className="alarm__summary-cards-wrap">
          {alarmCountData &&
            alarmCountData !== null &&
            alarmCountData?.length > 0 &&
            alarmCountData?.map((alarmType, index) => (
              <AlarmCards
                key={alarmType?.severity + index}
                alarmContainerClassName="alarms__dashboard__container-alarm-cards"
                cardId={`alarm-summary-${alarmType?.severity}`}
                alarmCount={alarmType?.alarmCount}
                headerText={alarmType?.severity}
                selectedCard={selectedAlarmCard}
                loader={loader}
              />
            ))}
        </div>
      )}

      <div className="noc_right_panel_alarm__summary-table">
        {!newlist ? (
          <AlarmTableSkeleton />
        ) : (
          <DataGridPro
            rows={getRows() ?? []}
            columns={columns}
            disableColumnMenu
            disableColumnReorder
            key={'alarm-summary-table'}
            className={'noc_right_panel_alarm__summary-table'}
            rowHeight={36}
            loading={newDashboardAlarmSummaryTableLoader || false}
            slots={{
              footer: () => null,
              noRowsOverlay: NoDataComponentAlarms,
              columnSortedAscendingIcon: SortedAscendingIcon,
              columnSortedDescendingIcon: SortedDescendingIcon,
              loadingOverlay: LoginLoader
            }}
            getRowClassName={(): string => {
              return 'alarm__summary__table-dashboard-row';
            }}
            sortingMode="server"
            onSortModelChange={handleSortModelChange}

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onRowClick={(rowData: GridRowParams<GridValidRowModel>, e) => {
              //navigate('/alarms?alarmId=' +rowData.row );
              (handleSelectedAlarm(e, rowData.row))
            }
            }
          />
        )}
      </div>

    </div>
  );
};

export default AcNocAlarmSummary;